
import Vue from 'vue';
import Component from 'vue-class-component';
import LookupMixin from './lookupMixin';
import { ResolveController } from 'rt/UIApiControllers/UI/Smart/ResolveController';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'CatalogCategoryInput',
})
export default class CatalogCategoryInput extends LookupMixin {
  resolveController = new ResolveController(Vue.axios);

  async resolve(id: number): Promise<string> {
    return (await this.resolveController.CatalogCategory(id)).name;
  }

  protected get identifier(): string {
    return 'CatalogCategory';
  }
}
